import React from 'react';

import DataConnector from 'connect/DataConnector';
import {GridWithMinimalCells} from 'constants/SampleConstants';
import HorizontalThrobber from 'ui-library/HorizontalThrobber';

import * as StorableActions from '../StorableActions';
import StorableStore from '../StorableStore';
import GridCellsSelector, {GridCellsSelectorProps} from './GridCellsSelector';

export interface GridCellsSelectorContainerConnectorProps extends Omit<GridCellsSelectorProps, 'grid'> {
  gridId: string;
  onLoadGrid?: () => void;
}
interface GridCellsSelectorContainerConnectorEnhancedProps {
  grid?: GridWithMinimalCells | null;
}

class GridCellsSelectorContainerConnector extends DataConnector<
  GridCellsSelectorContainerConnectorProps,
  GridCellsSelectorContainerConnectorEnhancedProps
> {
  shouldSubscribeToRedux = false;
  stores = [StorableStore];

  enhanceProps(): GridCellsSelectorContainerConnectorEnhancedProps {
    return {grid: this.storableStore().getGrid(this.props.gridId)};
  }
}

/*
 * Lightweight wrapper around GridCellsSelector that handles fetching the grid.
 */
class GridCellsSelectorContainer extends React.Component<
  GridCellsSelectorContainerConnectorProps & GridCellsSelectorContainerConnectorEnhancedProps
> {
  componentDidMount(): void {
    if (this.props.grid && this.props.onLoadGrid) {
      this.props.onLoadGrid();
    }
    StorableActions.fetchGrid(this.props.gridId);
  }

  componentDidUpdate(
    prevProps: GridCellsSelectorContainerConnectorProps & GridCellsSelectorContainerConnectorEnhancedProps,
    prevState: {}
  ): void {
    if (prevProps.gridId !== this.props.gridId) {
      StorableActions.fetchGrid(this.props.gridId);
    }
    if (!prevProps.grid && this.props.grid && this.props.onLoadGrid) {
      this.props.onLoadGrid();
    }
  }

  render(): JSX.Element {
    const grid = this.props.grid;
    if (grid == null) {
      return (
        <div className="u-spacing-top text-center">
          <HorizontalThrobber />
        </div>
      );
    }
    return <GridCellsSelector {...this.props} grid={grid} />;
  }
}

export default GridCellsSelectorContainerConnector.connect(GridCellsSelectorContainer);
